var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchBlue = function SvgSearchBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.029 13.568a.75.75 0 0 0-1.061 1.06l1.06-1.06Zm2.44 4.562a.75.75 0 1 0 1.061-1.06l-1.06 1.06ZM13.252 3.723a6.737 6.737 0 0 1 0 9.528l1.06 1.06a8.237 8.237 0 0 0 0-11.648l-1.06 1.06Zm0 9.528a6.737 6.737 0 0 1-9.528 0l-1.06 1.06a8.237 8.237 0 0 0 11.649 0l-1.06-1.06Zm-9.528 0a6.737 6.737 0 0 1 0-9.528l-1.06-1.06a8.237 8.237 0 0 0 0 11.649l1.06-1.06Zm0-9.528a6.737 6.737 0 0 1 9.528 0l1.06-1.06a8.237 8.237 0 0 0-11.648 0l1.06 1.06Zm9.245 10.905 3.502 3.502 1.06-1.06-3.501-3.502-1.061 1.06Z",
    fill: "#1D76BB"
  })));
};

export default SvgSearchBlue;